
    import { defineComponent } from 'vue';
    import Icon from '../Icon.vue';
    import { mdiPencil } from '@mdi/js';
    import ZoneContent from '../signage-layouts-preview/zone-content.vue';

    export default defineComponent({  
        data() {
            return {
                mdiPencil
            }
        },

        props: {
            signageLayout: {
                type: Object,
                default: null
            },
            showEdit: {
                type: Boolean,
                default: true
            }
        },

        components: {
            Icon,
            ZoneContent
        },

        methods: {
            zoneFocus(zoneNumber: number) {
                this.$emit('zoneFocus', zoneNumber);
            },

            getZoneContent(zoneNumber: number) {
                return this.signageLayout.signageZones.find((x: any) => x.zoneNumber == zoneNumber);
            },

            getLayoutId(): string | undefined {
                if (!this.signageLayout) return undefined;
                return this.signageLayout.id || this.signageLayout._id || undefined;
            }
        }
    })
